import { render, staticRenderFns } from "./CardExpertContent.vue?vue&type=template&id=8727c110&scoped=true&"
import script from "./CardExpertContent.vue?vue&type=script&lang=js&"
export * from "./CardExpertContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8727c110",
  null
  
)

export default component.exports